<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{$t('form.sales-receipt.numero_de_justificatif_d_achat')}}
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <span class="font-bold" v-if="selected">
                    {{selected[0].value}}
                </span>
            </template>

            <template v-slot:open>
                <sav-form
                v-if="data"
                :data-src="data"
                :callback="end"
                :id="$options.name"
                />
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'sales-receipt',
    extends: FormCardExtension,

    methods: {
        async init() {
            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            // Init form
            this.data = [
                {
                    type: 'text',
                    label: this.$t('form.sales-receipt.numero_de_justificatif_d_achat'),
                    required: true
                }
            ]
        },

        getNextRoute() {
            let blockData = this.$formTool.blockData(this.$options.name)
            return this.selected && this.selected.value == 'no' ? blockData.next.no : blockData.next.yes
        },

        end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.nextBlock = this.$formTool.blockData(this.$options.name).next
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/shop/SalesReceiptCard.vue